'use client'

import useTranslations from '@snowball-tech/common/hooks/useTranslations'
import { Typography } from '@snowball-tech/fractal/dist/src/components/Typography'
import { cj } from '@snowball-tech/fractal/dist/src/styles/helpers'
import { useSearchParams } from 'next/navigation'

import { useState } from 'react'

import HomeSubscribeForm from './SubscribeForm'

type Props = {
  color?: 'primary' | 'yellow'
  forceDisplay?: boolean
}
export default function HomePageSubscribe({
  color = 'primary',
  forceDisplay = false,
}: Props) {
  const searchParams = useSearchParams()
  const $t = useTranslations()

  const [isSubmitted, setIsSubmitted] = useState(
    searchParams.get('message') === 'signup-successfull',
  )

  return (
    <div
      className={cj(
        'flex w-full justify-center border-t-2 border-normal px-3 py-5',
        forceDisplay ? '' : 'lg:hidden',
        color === 'yellow' ? 'bg-decorative-yellow-70' : 'bg-primary',
      )}
    >
      <div className="flex max-w-screen-md flex-col items-center justify-center gap-3">
        <Typography variant="heading-3">
          {$t(
            isSubmitted ? 'subscribe.title.submitted' : 'home.subscribe.title',
          )}
        </Typography>

        {!isSubmitted && (
          <Typography variant="body-1-median">
            {$t('home.subscribe.description')}
          </Typography>
        )}

        <div className="flex w-full flex-col gap-1">
          {!isSubmitted && (
            <Typography>{$t('subscribe.form.signup.input.label')}</Typography>
          )}

          <HomeSubscribeForm
            origin="home"
            onSubmit={() => setIsSubmitted(true)}
          />
        </div>
      </div>
    </div>
  )
}
